import DOMPurify from 'dompurify';

export const sanitizeTextWithHtml = (html) => {
  if (html === null) {
    return { __html: '' };
  }
  let labelText = html;
  const reOpening = /<span style="text-decoration:\s*underline;">/g;
  const reEnding = /<\/span>/g;
  labelText = labelText.replace(reOpening, '<u>');
  labelText = labelText.replace(reEnding, '</u>');
  const clean = DOMPurify.sanitize(labelText);
  const cleanHtml = { __html: clean };

  return cleanHtml;
};